export const HUMPS_REGEX = /(?=[A-Z])/;
